export default __webpack_public_path__ + "static/media/PAFI_Announcement of Extraordinary GMS 2025.5eb130e6.pdf";